// extracted by mini-css-extract-plugin
export default {"preferences":"my_preferences-module___preferences___d62788bc","loaderWrapper":"my_preferences-module___loaderWrapper___aac93270"};